
import 'picturefill'; 
import 'picturefill/dist/plugins/mutation/pf.mutation.min';
import 'waypoints/lib/noframework.waypoints.min';
import 'lazysizes';

class JournalLoader {

	constructor(  ) {

		this.isInitialized = false;
        this.baseUrl = '/api/v1/journal.json';

        this.state = {
            loadedItems: [],
            everythingIsLoaded: false,
            loadMoreUrl: null,
        }
		
		this.journalList = document.querySelector('.journal__list');
		this.journalFooter = document.querySelector('.journal__footer');
		this.journalLoadMoreButton = document.querySelector('.journal__footer button');

		this.init();

	}


	buildItem( item ) {

        let node = document.createElement("article")
        node.classList.add('journal__item')

		if ( item.image ) {
			
			let image = document.createElement('img')
			image.classList.add('lazyload')
			image.sizes = '50vw'
			image.alt = item.image.title
			image.src = item.placeholderImage.src
			image.dataset.srcset = item.image.srcset

			let imageContainer = document.createElement('div')
			imageContainer.classList.add('journal__image-container')
			imageContainer.setAttribute('style', `padding-top: ${((Math.floor(item.image.height)/Math.floor(item.image.width))*100).toFixed(2)}%;`)
			imageContainer.appendChild(image)

			node.appendChild(imageContainer)

		}
		
		let header = document.createElement('h3')
		header.classList.add('journal__item-header')
		header.innerHTML = item.date
		node.appendChild(header)

		let content = document.createElement('div')
		content.classList.add('journal__item-content')
		content.innerHTML = item.ingress
		node.appendChild(content)

		setTimeout(() => {
            node.classList.add('journal__item--visible');
        }, 100);

        return node

	}

	fetchData( url ) {

		// Set up our HTTP request
		var xhr = new XMLHttpRequest();

		// Setup our listener to process completed requests
		xhr.onload = function () {

			// Process our return data
			if (xhr.status >= 200 && xhr.status < 300) {
				
				const response = JSON.parse(xhr.response)
				
				response.data.forEach(item => {
					this.state.loadedItems.push( item );
					this.journalList.appendChild( this.buildItem( item ) )
				})
				
				this.journalFooter.classList.remove('journal__footer--is-loading');
				this.journalLoadMoreButton.removeAttribute('disabled');

				if ( this.journalLoadMoreButton && response.meta.pagination.links.next ) {
					this.journalFooter.classList.add('journal__footer--visible');
					this.state.loadMoreUrl = response.meta.pagination.links.next
				} else {
					this.journalFooter.classList.remove('journal__footer--visible');
					this.state.everythingIsLoaded = true
                    this.state.loadMoreUrl = null
				}
                
                // Save data in sessionStorage
                window.sessionStorage.setItem( 'journalList', JSON.stringify( this.state ) )


			} else {
				// What do when the request fails
				console.log('The request failed!');
			}

			// Code that should run regardless of the request status
			// console.log('This always runs...');

		}.bind(this);

		// Create and send a GET request
		// The first argument is the post type (GET, POST, PUT, DELETE, etc.)
		// The second argument is the endpoint URL
		xhr.open('GET', url);
		xhr.send();

	}

	init() {

		if ( !this.journalList ) {
			return;
		}

		// Check for locally stored projects
        const state =  window.sessionStorage.getItem('journalList')

        if ( state ) {
            
            // Use stored data if available
            this.state = JSON.parse(state)
            this.state.loadedItems.forEach(item => {
                this.journalList.appendChild( this.buildItem( item ) )
            })
            if ( this.state.loadMoreUrl && !this.state.everythingIsLoaded ) {
                this.journalFooter.classList.add('journal__footer--visible')
            }

        } else {

            // Fetch new data
            this.fetchData(this.baseUrl);

        }

		if ( this.journalLoadMoreButton ) {

			this.journalLoadMoreButton.addEventListener('click', e => {
				e.preventDefault();

				this.journalLoadMoreButton.setAttribute('disabled', 'disabled')
				this.journalFooter.classList.add('journal__footer--is-loading');

				setTimeout(() => {
					this.fetchData( this.state.loadMoreUrl );
				}, 500);

				
			});

		}

	}

}

export default JournalLoader
